import { Component, inject } from '@angular/core';
import {Router} from "@angular/router";
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MobileAppModalComponent} from "app/components/CommonModals/CommonModals.component";

@Component({
  selector: 'continue-on-modal',
  standalone: true,
  templateUrl: './continue-on.component.html',
})
export class ContinueOnModalComponent {
  private router = inject(Router);
  activeModal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);

  public urlTo = '/welcome'

  setUrlTo(urlTo: string) {
    this.urlTo = urlTo;
  }

  async continueOnApp() {
    const blur = this.blurWatch(300);
    const visibility = this.visibilityWatch(5000);

    window.location.href = 'nwm://com.nicolawealth.nicola';

    let showAppModal = false;
    if(!(await blur) || !(await visibility)) {
      showAppModal = true;
    }
    this.activeModal.dismiss('Continue on App');
    this.router.navigate(['/account/login']).then(async () => {
      if (showAppModal) {
        setTimeout(() => {
          this.modalService.open(MobileAppModalComponent, {centered: true, size: 'lg'});
        }, 300);
      }
    });

  }

  continueOnSite() {
    this.activeModal.dismiss('Continue on Site');
    this.router.navigate([this.urlTo]).then();
  }

  blurWatch(timeout: number): Promise<boolean> {
    return new Promise((resolve) => {
      const cb = () => {
        window.removeEventListener('blur', cb);
        resolve(true);
      };
      window.addEventListener('blur', cb);
      setTimeout(() => {
        window.removeEventListener('blur', cb);
        resolve(false);
      }, timeout);
    });
  }

  visibilityWatch(timeout: number): Promise<boolean> {
    return new Promise((resolve) => {
      const cb = () => {
        document.removeEventListener('visibilitychange', cb);
        resolve(true);
      };
      document.addEventListener('visibilitychange', cb);
      setTimeout(() => {
        document.removeEventListener('visibilitychange', cb);
        resolve(false);
      }, timeout);
    });
  }
}
